import t from"react";import r from"./Button.js";const e=t.forwardRef(((e,o)=>t.createElement(r,{variant:"link",component:"a",ref:o,...e})));export{e as default};
//# sourceMappingURL=ButtonLink.js.map
